export default {
  "nearby": "現在地周辺",
  "alerts": "お知らせ",
  "explore": "探す",
  "cart": "カート",
  "account": "アカウント",
  "services": "サービス",
  "foodQuestion": "何を注文しますか？",
  "foodSearch": "店舗・料理・商品を検索",
  "nearYou": "お近くの店舗",
  "chooseLocation": "現在地を選択",
  "chooseLocationHelp": "配達可能な店舗を表示するために位置情報が必要です。",
  "chooseAddress": "住所を選択",
  "changeZone": "エリアを変更",
  "searchingStores": "店舗を検索中…",
  "storesAvailable": "店舗が利用可能",
  "noStores": "このエリアで利用できるレストランはありません。",
  "newStores": "新しいお店",
  "justArrived": "新着",
  "newLabel": "新規",
  "recommendedLabel": "おすすめ",
  "popularLabel": "人気",
  "recommendedEyebrow": "店舗のおすすめ",
  "recommendedProducts": "おすすめ商品",
  "addProduct": "追加",
  "openNow": "営業中",
  "closedNow": "営業時間外",
  "exploreTitle": "お探しのものを検索",
  "exploreHelp": "このエリアの店舗・料理・商品を検索できます。",
  "searchThreeChars": "3文字以上入力してください。",
  "searching": "検索中…",
  "noSearchResults": "結果が見つかりません。",
  "businesses": "店舗",
  "viewMenu": "メニューを見る",
  "servicesTitle": "利用できるサービス",
  "servicesHelp": "アプリ内で利用可能なサービスを選択してください。",
  "loadingServices": "サービスを読み込み中…",
  "enterService": "サービスを依頼",
  "anotherAddress": "別の住所を選択してください。",
  "loadingMenu": "メニューを読み込み中…",
  "backStores": "店舗一覧へ戻る",
  "searchMenu": "メニュー内を検索",
  "noProducts": "商品が見つかりません",
  "anotherWord": "別のキーワードをお試しください。",
  "minimumOrder": "最低注文額",
  "products": "商品",
  "viewCart": "カートを見る",
  "yourOrder": "ご注文",
  "emptyCart": "カートは空です",
  "emptyCartHelp": "店舗の商品を追加して注文を始めましょう。",
  "browseStores": "店舗を探す",
  "subtotal": "小計",
  "deliveryCheckout": "配送料はチェックアウト時に住所から計算されます。",
  "checkoutContinue": "チェックアウトへ進む",
  "confirmOrder": "注文を確定",
  "backCart": "カートに戻る",
  "deliverAt": "配達先",
  "change": "変更",
  "reference": "部屋番号・階・目印",
  "orderNote": "店舗へのメモ",
  "payment": "支払い方法",
  "cash": "受け取り時に現金払い",
  "selected": "選択済み",
  "estimatedDelivery": "配送料の目安",
  "total": "合計",
  "loginFinish": "注文を完了するにはログインしてください",
  "loginContinue": "ログインして続ける",
  "tracking": "配送状況",
  "myOrders": "注文履歴",
  "loginOrders": "注文を確認するにはログインしてください",
  "noOrders": "まだ注文はありません",
  "profile": "プロフィール",
  "myAccount": "マイアカウント",
  "login": "ログイン",
  "register": "アカウント作成",
  "name": "お名前",
  "phone": "WhatsApp／電話番号",
  "email": "メールアドレス",
  "password": "パスワード",
  "enter": "ログイン",
  "registerMe": "登録する",
  "language": "言語",
  "languageHelp": "新しいすべての画面に適用されます",
  "notifications": "通知",
  "notificationsHelp": "注文、キャンペーン、最新情報",
  "notificationsEnabled": "この端末で有効です",
  "notificationsBlocked": "ブラウザでブロックされています",
  "notificationsBlockedHelp": "通知がブロックされています。鍵アイコンまたはサイト設定から通知を許可してください。",
  "notificationsUnsupported": "このブラウザは通知に対応していません",
  "notificationsError": "通知の許可を求められませんでした。もう一度お試しください。",
  "activate": "有効にする",
  "review": "許可を確認",
  "logout": "ログアウト",
  "history": "履歴と配送状況",
  "whereDeliver": "どちらへ配達しますか？",
  "sharedAddress": "この住所はレストラン、配送、今後のサービスで共通して使用されます。",
  "currentLocation": "現在地を使用",
  "locating": "現在地を確認中…",
  "popularPlaces": "人気の場所",
  "selectAddress": "住所を選択",
  "allInOne": "すべてをひとつの場所で",
  "exploreHuaraz": "ワラスを探す",
  "portalSub": "お近くの食事、配送、新しいサービス。",
  "restaurants": "レストラン",
  "taxiLabel": "タクシー",
  "supermarket": "スーパーマーケット",
  "orderFood": "料理や商品を注文",
  "soon": "近日公開",
  "available": "利用可能",
  "navBusinesses": "店舗",
  "navJoin": "参加する",
  "heroTitle": "ワラスのすべてを、ご自宅まで",
  "heroDescription": "地元のレストランや店舗を見つけ、簡単な手順で注文してお好きな場所で受け取れます。",
  "choose": "選ぶ",
  "favoriteBusiness": "お気に入りの店舗",
  "order": "注文",
  "easySecure": "簡単・安全",
  "receive": "受け取る",
  "atYourLocation": "ご指定の場所で",
  "exploreFromPc": "パソコンから探す",
  "localBusinesses": "地元の店舗",
  "deliveryInHuaraz": "ワラス市内へ配達",
  "orderTracking": "注文の追跡",
  "liveApp": "ライブアプリ",
  "shopHere": "ここから直接注文できます",
  "shipments": "配送",
  "openApp": "アプリを開く",
  "dailyServices": "毎日のためのサービス",
  "dailyServicesDescription": "買い物、配送、地元のサービスをひとつのプラットフォームで。",
  "restaurantServiceDescription": "地元の人気店から料理や商品を注文できます。",
  "exploreBusinesses": "店舗を探す",
  "pickupDelivery": "集荷・配達",
  "pickupDescription": "地点Aから地点Bまで荷物をお届けします。",
  "requestDelivery": "配送を依頼",
  "taxiDescription": "すばやく安全にタクシーを依頼できます。",
  "temporarilyUnavailable": "現在利用できません",
  "requestTaxi": "タクシーを呼ぶ",
  "verySoon": "近日公開",
  "buyLocal": "地元で買おう",
  "meetBusinesses": "加盟店を見る",
  "previousBusinesses": "前の店舗",
  "nextBusinesses": "次の店舗",
  "growTogether": "一緒に成長しましょう",
  "joinDelivery": "Delivery Huarazに参加",
  "joinDescription": "ワラスで販売、配送、運営を管理するためのツールを提供します。",
  "forBusinesses": "店舗向け",
  "growSales": "売上を伸ばす",
  "growSalesDescription": "注文やメニューを管理し、運営の管理を保ちながらより多くのお客様に届けます。",
  "registerBusiness": "店舗を登録",
  "forDrivers": "配達員向け",
  "earnDelivering": "配達で収入を得る",
  "driverDescription": "移動中でも統合されたツールから注文、配送、通知を受け取れます。",
  "applyDriver": "配達員に応募",
  "footerDescription": "食事、配送、地域サービスをひとつの場所で。",
  "enterApp": "アプリに入る",
  "closeApp": "アプリを閉じる",
  "gpsPrompt": "GPSを有効にすると正確な住所でスムーズに配達できます。",
  "shopping": "買い物",
  "events": "イベント",
  "mobileJoinDescription": "店舗と配達員には専用のツール、通知、作業パネルがあります。",
  "haveBusiness": "店舗をお持ちですか？",
  "mobileBusinessDescription": "注文やメニューを管理し、ワラスのより多くのお客様へ届けましょう。",
  "haveMotorcycle": "バイクをお持ちですか？",
  "mobileDriverDescription": "統合パネルから注文や配送、新しいサービスで収入を得られます。",
  "myAddresses": "住所",
  "addressHelp": "自宅、勤務先、ホテルなど",
  "walletCredits": "ウォレットとクレジット",
  "walletHelp": "残高、チャージ、特典",
  "myFavorites": "お気に入り",
  "favoriteHelp": "保存した店舗",
  "myCart": "マイカート",
  "cartHelp": "買い物を続ける",
  "helpInfo": "ヘルプと情報",
  "helpInfoDesc": "よくある質問、ポリシー、利用規約",
  "forgotPassword": "パスワードを忘れた",
  "favoriteTitle": "お気に入り店舗",
  "favoriteLogin": "お気に入りを保存するにはログインしてください",
  "noFavoritesZone": "このエリアにお気に入り店舗はありません",
  "favoriteEmptyHelp": "メニューからお気に入りの店舗を保存できます。",
  "reviews": "レビュー",
  "backMenu": "メニューに戻る",
  "noReviews": "まだレビューはありません。",
  "infoTitle": "ヘルプと情報",
  "recoverAccess": "アカウントを復旧",
  "newPassword": "新しいパスワード",
  "recoverHelp": "Delivery Huarazに登録したメールアドレスへコードを送信します。",
  "sendCode": "コードを送信",
  "verifyCode": "コードを確認",
  "savePassword": "パスワードを保存",
  "cartProductsTitle": "カート内の商品",
  "clearCart": "すべて削除",
  "decreaseQuantity": "数量を減らす、または商品を削除",
  "increaseQuantity": "数量を増やす",
  "cartCommentPlaceholder": "店舗へのコメントやご要望を入力…",
  "coupon": "クーポン",
  "applyCoupon": "適用",
  "couponInvalid": "このクーポンは利用できません。",
  "discountApplied": "割引を適用しました",
  "paymentDetails": "お支払い明細",
  "deliveryFee": "配送料",
  "businessCharge": "店舗手数料",
  "discount": "割引",
  "totalToPay": "お支払い合計",
  "confirmDeliveryAddress": "配達先住所を確認してください",
  "selectAnAddress": "住所を選択",
  "verifyCurrentAddress": "現在いる場所に注文が届くことをご確認ください。",
  "addressConfirmed": "住所を確認しました",
  "correctAddress": "はい、この住所で間違いありません",
  "confirmAddressHelp": "お支払いに進むには住所の確認が必要です",
  "continuePayment": "支払いへ進む",
  "fulfillmentQuestion": "注文の受け取り方法を選択してください",
  "deliveryOption": "配達",
  "deliveryOptionHelp": "ご指定の住所へお届けします",
  "pickupOption": "店舗受け取り",
  "pickupOptionHelp": "準備完了後に店舗で受け取ります",
  "pickupAtStore": "店舗で受け取る",
  "pickupAddressHelp": "店舗の住所をご確認ください",
  "pickupReadyHelp": "準備ができ次第、店舗からお知らせします。",
  "noCost": "無料",
  "noDeliveryFee": "配送料なし",
  "howPayPickup": "店舗で受け取る際のお支払い方法は？",
  "howPayDelivery": "注文受け取り時のお支払い方法は？",
  "paymentMethodForLocation": "現在地で利用可能なお支払い方法",
  "payOnDeliveryLabel": "受け取り時に支払う",
  "payOnDeliveryTitle": "現金・Yape・Plin",
  "payOnDeliveryHelp": "注文到着時のお支払い方法を選択してください。",
  "choosePayment": "選択",
  "choosePaymentOnDelivery": "受け取り時のお支払い方法を選択",
  "confirmAddressTitle": "住所を確認",
  "addressMapInstructions": "GPSを使用した後、配達先の入口までマーカーを正確に移動してください。",
  "savedAddressesTitle": "保存済みの住所",
  "genericAddress": "住所",
  "useGpsNow": "現在地のGPSを使用",
  "gpsUnsupported": "この端末ではGPS位置情報を取得できません。",
  "gpsPermissionRequired": "GPSを使用するには位置情報の許可が必要です。",
  "gpsUnavailableHelp": "正確な位置を取得できませんでした。通りを検索するか、マーカーを移動してください。",
  "gpsAccuracy": "おおよその精度",
  "gpsMoveMarker": "マーカーを移動して修正してください。",
  "gpsConfirmPoint": "地図上の地点を確認してください。",
  "addressSearchPlaceholder": "通り、大通り、ホテル、目印を検索",
  "search": "検索",
  "addressNotFoundHelp": "住所が見つかりませんでした。入口までマーカーを移動してください。",
  "mapNotConfigured": "地図はまだ設定されていません。",
  "mapLoadFailed": "地図を読み込めませんでした。",
  "dragMarkerHelp": "入口までマーカーをドラッグしてください",
  "addressHouseLabel": "番地、階、目印",
  "addressHousePlaceholder": "例：青い家、2番ドア",
  "saveAs": "名前を付けて保存",
  "homeTag": "自宅",
  "workTag": "職場",
  "hotelTag": "ホテル",
  "otherTag": "その他",
  "saveInMyAddresses": "マイ住所に保存",
  "savingAddress": "保存中…",
  "confirmThisAddress": "この住所を確認",
  "popularHuarazPlaces": "ワラスの主な場所",
  "noStoresAtPoint": "この地点で利用できる店舗が見つかりませんでした。",
  "gpsOutsideCoverageHelp": "GPSがサービスエリア外を示している可能性があります。入口までマーカーを移動してください。",
  "correctMapLocation": "地図上の位置を修正",
  "checkingCurrentLocation": "現在地を確認しています…",
  "checkAddressWithGps": "GPSでこの住所を確認",
  "locationVerifiedForOrder": "この注文の位置情報を確認しました。",
  "gpsMatchesDeliveryAddress": "現在地は配達先住所と一致しています。",
  "youMayHaveMoved": "別の場所にいる可能性があります",
  "currentLocationDistance": "現在のGPS位置は選択した住所から約{distance}km離れています。",
  "useCurrentGpsAndAdjust": "GPSを使用して調整",
  "deliverToSelectedAddress": "選択した住所に配達",
  "gpsNeedsConfirmation": "GPS位置の確認が必要です",
  "gpsAccuracyTooLow": "現在の精度は約{accuracy}mです。注文前に地点を確認してください。",
  "reviewLocationOnMap": "地図で位置を確認",
  "gpsCouldNotVerify": "現在地を確認できませんでした",
  "addressVerificationExpired": "配達先住所をもう一度確認する必要があります。カートに戻ります。",
  "back": "戻る", "close": "閉じる", "home": "ホーム", "offers": "お得情報",
  "loadingNavigation": "ナビゲーションを読み込み中", "mainNavigation": "メインナビゲーション",
  "customizeOrder": "ご注文をカスタマイズ", "loadingProduct": "商品を読み込み中…",
  "chooseOptions": "オプションを選択", "chooseOneOption": "1つ選択してください", "chooseUpTo": "最大{count}個まで選択",
  "optional": "任意", "additional": "追加", "additionals": "追加オプション",
  "continue": "続ける", "continueAndAdd": "続けて追加",
  "exclusiveOffers": "限定オファー", "yapePromos": "Yapeプロモ",
  "yapeSpecialPrices": "Yapeでのお支払い限定価格です。", "yapeLocationHelp": "配達可能なお店を確認します。",
  "searchPromoOrBusiness": "プロモやお店を検索", "loadingPromotions": "プロモーションを読み込み中…",
  "promotionsLoadError": "プロモーションを読み込めませんでした。", "noYapePromos": "現在利用できるYapeプロモはありません。",
  "comeBackForOffers": "新しいオファーをお待ちください。", "availablePromotions": "利用可能なプロモーション",
  "yapeOnly": "Yape限定", "viewMyOrder": "注文を見る", "benefitsForYou": "あなたへの特典", "seeAll": "すべて見る",
  "exclusiveDiscounts": "限定割引", "accordingToPromotions": "プロモーションによる",
  "deliveriesAndPickups": "配達と店頭受取", "accordingToCoverage": "配達エリアによる",
  "shoppingBenefits": "購入特典", "moreNewsSoon": "新しい特典を準備中",
  "category": "カテゴリー", "backToCategories": "カテゴリーに戻る",
  "storesNearLocation": "現在地周辺で利用可能なお店です。", "searchIn": "検索：",
  "categoryAddressHelp": "このカテゴリーのお店を表示するため住所が必要です。", "inYourZone": "お客様のエリア",
  "loadingBusinesses": "お店を読み込み中", "businessesLoadError": "お店を読み込めませんでした。",
  "noCategoryBusinesses": "お客様のエリアでは{category}のお店を利用できません。",
  "discoverMenuPromotions": "メニューとプロモーションを見る。",
  "yapeExclusivePayment": "Yape支払い限定プロモーション", "yapePromoOrderNotice": "この注文にはYapeプロモ商品が含まれています。",
  "exclusivePaymentMethod": "限定支払い方法", "payWithYape": "Yapeで支払う", "keepPromotionalPrice": "プロモーション価格の適用に必要です",
  "integrationPending": "連携準備中", "storeClosed": "お店は営業時間外です", "checkoutStoreClosedHelp": "お店が営業を再開するまで、この注文を確定できません。",
  "selectOptionToContinue": "続けるにはオプションを選択してください。", "cash": "現金", "cashChangeHelp": "お釣りが必要か指定してください", "coordinatedTransfer": "送金を調整",
  "cashAmountPlaceholder": "お支払い金額を入力（例：50）", "processing": "処理中…", "confirmCashOrder": "現金注文を確定",
  "confirmOrderWith": "{method}で注文を確定", "cashChangeInstructions": "お釣りが必要な場合は紙幣の金額を入力してください。ちょうどの場合は空欄で構いません。",
  "transferPickupInstructions": "アプリ内では決済されません。送金前にお店へ{method}の送金先を確認してください。",
  "transferDeliveryInstructions": "アプリ内では決済されません。送金前にお店または配達員へ{method}の送金先を確認してください。",
  "selectPaymentMethod": "支払い方法を選択", "storeActions": "お店の操作", "searchProducts": "商品を検索", "shareStore": "お店を共有",
  "storeClosedMenuHelp": "営業時間外です。メニューはご覧いただけます。", "closeNotice": "お知らせを閉じる",
  "searchInStore": "{store}で検索", "storeCategories": "お店のカテゴリー", "customizable": "カスタマイズ可能", "added": "追加済み",
  "productDetail": "商品詳細", "customizeAndAdd": "カスタマイズして追加", "addToOrder": "注文に追加", "addedToCart": "カートに追加しました",
  "storeNotAcceptingOrders": "このお店は営業時間外のため、現在注文を受け付けていません。"
};
